<template>
	<div class="CreateAccount">
		<h2>{{lang.signup.account.header}}</h2>
		<p class="littleAndBold">{{lang.signup.account.introText}}</p>

		<form @submit.prevent="" autocomplete="on">
			<Input ref="username" dataKey="username" :label="lang.signup.account.username.label" :helperText="lang.signup.account.username.helperText" validationKey="username" />
			<Input ref="password" name="password" dataKey="password" type="password" :label="lang.signup.account.password.label" :helperText="lang.signup.account.password.helperText" :validationFunction="passwordValidation" />
			<Input ref="email" name="email" autocomplete="email" dataKey="email" type="email" :label="lang.signup.account.email.label" :helperText="lang.signup.account.email.helperText" validationKey="email" />

      <Input ref="phone" :validationFunction="validatePhoneNumber" name="phone" autocomplete="tel" dataKey="phone" type="tel" :label="lang.signup.account.publicPhoneNumber.label" :placeholder="phoneNumberPlaceholder" :helperText="lang.signup.account.publicPhoneNumber.helperText"/>
      <Input ref="contactName" dataKey="contactName" :label="lang.signup.account.contactName.label" :helperText="lang.signup.account.contactName.helperText" />
			<Select data-key="preferredLanguageCode"
				:values="availableLanguages"
				:label="lang.signup.account.preferredLanguage.label"
				:default="defaultLanguageCode"
				:helper-text="lang.signup.account.preferredLanguage.helperText"
			/>

			<Input ref="vatNumber" dataKey="vatNumber" validationKey="vatNumber" name="vatNumber" :label="`${lang.signup.account.vatNumber.label} ${lang.common.optional}`" :helperText="lang.signup.account.vatNumber.helperText"/>
			<Checkbox class="acceptToTermsOfUse littleAndBold" dataKey="acceptToTermsOfUse" :labelHTML="lang.signup.account.terms.text.replace('{0}', `<a class='greenLink' href='${lang.signup.account.terms.link}' target='_blank'>${lang.signup.account.terms.linkText}</a>`)" />
		</form>
		<div class="nextPageControls">
			<Button class="onlyText" @click="$router.push('/')">{{lang.signup.button.back}}</Button>
			<Button :disabled="!pageIsValid" @click="$router.push('profile')">{{lang.signup.button.continue}}</Button>
		</div>
	</div>
</template>

<script>
import Input from '../components/Input.vue'
import Button from '../components/Button.vue'
import Checkbox from '../components/Checkbox.vue'
import Select from '../components/Select'
import lang, {langId} from '../lang'
import { getCountryObject } from '../util/env'
const PNF = require('google-libphonenumber').PhoneNumberFormat
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
import { mapActions } from 'vuex'

const refKeysToValidate = [
	'username',
	'password',
	'email',
	'phone'
]

export default {
	name: 'CreateAccount',
	props: [],
	data: () => ({
		lang,
		phoneValidationResult: null, // null | true | false
		pageRefsAreValid: false,
		availableLanguages: [],
		defaultLanguageCode: langId,
	}),
	computed: {
		phoneNumberPlaceholder() {
			let state = this.$store.state
			let countryObject = getCountryObject(state.country)
			return `+${countryObject.countryCode} ...`
		},
		pageIsValid() {
			let termsValid = this.$store.state.acceptToTermsOfUse
			let refsValid = this.pageRefsAreValid
			return termsValid && refsValid
		}
	},
	methods: {
		...mapActions(['setPartnerDataValue']),
		passwordValidation(value) {
			if (value && value.length < window.MIN_PASSWORD_LENGTH) {
				return lang.signup.account.password.validation.minLength.replace(
					'{0}',
					window.MIN_PASSWORD_LENGTH
				)
			} else {
				return null
			}
		},
		// Call this function everytime ref's value, ref's error or acceptToTermsOfUse changes
		validateRefs() {
			let invalidFound = false

			for (let refKey of refKeysToValidate) {
				let ref = this.$refs[refKey]
				if (!ref || !ref.value || ref.validationError) {
					invalidFound = true
				}
			}

			this.pageRefsAreValid = !invalidFound
		},
		// Falsy = valid, Truthy = error message
		validatePhoneNumber(phone) {
			if (!phone) {
				return
			}
			const state = this.$store.state
			try {
				phoneUtil.format(phoneUtil.parseAndKeepRawInput(phone, state.country.toUpperCase()), PNF.INTERNATIONAL)
			} catch(e) {
				return this.lang.signup.account.publicPhoneNumber.error
			}
		}

	},
	mounted() {
		window.envPromise.then(env => {
			this.availableLanguages = env.SUPPORTED_CONTACT_LANGUAGES_WITH_NAMES.map(({id, name}) => ({value: id, label: name}))
		})
		this.validateRefs()
		const refsChanged = () => {
			this.validateRefs()
		}
		for (let refKey of refKeysToValidate) {
			this.$watch(`$refs.${refKey}.value`, refsChanged)
			this.$watch(`$refs.${refKey}.validationError`, refsChanged)
		}
	},
	components: {
		Select,
		Input,
		Button,
		Checkbox,
	},
}
</script>

<style lang="stylus" scoped>
.CreateAccount {
	max-width: 400px;
	margin: 0 auto;
}
.acceptToTermsOfUse {
	margin-top: 35px;
	margin-bottom: 30px;
}
</style>
